{
  "2024-04-14": {
    "text": "Rendez-vous",
    "place": "Brocante de Printemps Cabris",
    "link": "https://www.facebook.com/Officedetourismecabris"
  },
  "2024-05-26": {
    "text": "Souhaitez",
    "place": "La fête des Mères",
    "link": "https://icalendrier.fr/fetes/fete-des-meres"
  },
  "2024-06-15": {
    "text": "Rendez-vous",
    "place": "Marché Nocturne Cabris",
    "link": "https://www.facebook.com/Officedetourismecabris"
  },
  "2024-07-07": {
    "text": "Rendez-vous",
    "place": "Marché Artisanal Cabris",
    "link": "https://www.facebook.com/Officedetourismecabris"
  },
  "2024-07-19": {
    "text": "Rendez-vous",
    "place": "Marché Nocturne Cabris",
    "link": "https://www.facebook.com/Officedetourismecabris"
  },
  "2024-08-16": {
    "text": "Rendez-vous",
    "place": "Marché Nocturne Cabris",
    "link": "https://www.facebook.com/Officedetourismecabris"
  },
  "2024-12-15": {
    "text": "Rendez-vous",
    "place": "Marché de Noël Cabris",
    "link": "https://www.facebook.com/Officedetourismecabris"
  }
}